<template>
  <div class="container">
    <div class="row">
      <div class="align-items-center w-100 text-white mt-5">
        <h1 class="align-items-center mt-40" align="center">Welcome</h1>
        <p class="align-items-center" align="center">to recover your password you need to enter your UserName or
          National ID</p>
      </div>



      <div class="col-md-4 mx-auto">
        <div class="panal card-container">
          <div class="panal-header">Forget Password</div>

          <div class="col-md-9 mx-auto ">
            <form name="form" @submit.prevent="GetEmailsListByUserName" v-if="!hide">
              <div class="form-group mt-40">

                <div class="form-check form-check-inline">
                  <input v-validate="'required'" class="form-check-input" type="radio" name="inlineRadioOptions"
                    id="inlineRadio1" value="1" v-model="selected">
                  <label class="form-check-label" for="inlineRadio1">UserName</label>
                </div>
                <div class="form-check form-check-inline">
                  <input v-validate="'required'" class="form-check-input" type="radio" name="inlineRadioOptions"
                    id="inlineRadio2" value="2" v-model="selected">
                  <label class="form-check-label" for="inlineRadio2">National ID</label>
                </div>
                <div v-if="errors.has('inlineRadioOptions')" class="alert alert-danger" role="alert">Please Select one
                  type</div>

              </div>




              <div class="input-group" v-if="selected == 1">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <font-awesome-icon icon="user" />
                  </div>
                </div>
                <input type="text" class="form-control" name="username" placeholder="Username"
                  v-model="InputUserName" />
              </div>

              <div class="input-group" v-if="selected ==2">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <font-awesome-icon icon="id-card" />
                  </div>
                </div>
                <input type="text" class="form-control" name="NationalID" placeholder="National ID"
                  v-model="NationalID" />
              </div>
              <!-- <div v-if="errors.has('NationalID')" class="alert alert-danger" role="alert">NationalID is required!</div> -->

              <div v-if="errors.has('username')" class="alert alert-danger" role="alert">Username is required!</div>

              <div class="form-group mt-40">
                <button class=" btn-block btn btn-outline-secondary" :disabled="loading">
                  <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                  <span>Get Your Email</span>
                </button>
              </div>

            </form>
            <div v-if="EmailList.length > 0">
              <ul class="list-group">
                Select Your Email
                <li class="list" v-for="email in EmailList" v-bind:key="email.ContactsSerial">
                  <input type="radio" name="name" :value="email.ContactsSerial" :id="email.ContactsSerial"
                    v-model="ContactID" />
                  <span>
                    {{ email.ContactDetails}}
                  </span>
                </li>
              </ul>
              <button class=" btn-block btn btn-outline-secondary" :disabled="loading" @click="SendEmail">
                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                <span>Send Password</span>
              </button>
             
              </div>
              <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>
 <b-link class=" " @click="$router.push('login')">

                        <span>Back to login</span>
                      </b-link>
            </div>
          </div>
        </div>
      </div>
    </div>




</template>

<script>
  import ApplicantDataServices from '../services/Applicant/ApplicantData.services';
  export default {
    data() {
      return {
        EmailList: [],
        InputUserName: '',
        NationalID: '',
        loading: false,
        selected: '',
        hide: false,
        ContactID: '',
        message: '',
        successful: ''
      }
    },
    computed: {
      currentUser() {
        return this.$store.state.auth.user
      }
    },
    methods: {
      GetEmailsListByUserName() {
        /*eslint-disable-next-line*/
        console.log(this.InputUserName)
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
            this.loading = false;
            return;
          }
          if (this.selected == 1) {
            ApplicantDataServices.GetApplicanrEmailByUserName(this.InputUserName).then(Response => {
              this.EmailList = Response.data
              this.loading = false
              this.hide = true
            }, error => {
              this.loading = false
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            });
          } else if (this.selected == 2) {
            ApplicantDataServices.GetApplicanrEmailByNationalID(this.NationalID).then(Response => {
              this.EmailList = Response.data
              this.loading = false
              this.hide = true
            }, error => {
              this.loading = false

              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            });
          }
 
        });
      },
      SendEmail() {
        ApplicantDataServices.SendForgetPasswordEmail(this.EmailList[0].serial, this.ContactID).then(Response => {
          this.EmailList = []
          this.message = Response.data
          this.hide = false
          this.loading = false
this.successful = true
        }, error => {
          this.loading = false
          this.successful = false
          /*eslint-disable-next-line*/
          console.log(error.response.data.Message)
          this.message =
            (error.response && error.response.data && error.response.data.Message) ||
            error.Message ||
            error.toString();
        });

      }


    }

  }
</script>

<style scoped>
  label {
    display: block;
    margin-top: 0px;
  }

  ul {
    list-style: none;
  }

  .list {
    font-size: 18px;
    margin: 5px 0;
  }

  .card-container.card {
    max-width: 350px !important;
    padding: 40px 40px;
  }

  .card {
    background-color: #f7f7f7;
    padding: 20px 25px 30px;
    margin: 0 auto 25px;
    margin-top: 50px;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  }

  .profile-img-card {
    width: 96px;
    height: 96px;
    margin: 0 auto 10px;
    display: block;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
  }

  .panal {
    background: #0000009e;
    border-radius: 10px 10px 0px 0px;
    color: #fff;
    padding: 0px 0px 50px 0px;

  }

  .panal-header {
    background: #FFFFFF;
    color: #285475;
    text-align: center;
    border-radius: 10px 10px 0px 0px;
    padding: 15px;
    font-size: 30px;
    font-weight: bold;
    -moz-box-shadow: inset 0 0 5px #000000;
    -webkit-box-shadow: inset 0 0 5px #000000;
    box-shadow:
  }

  .mt-20 {
    margin-top: 20px;
  }

  .mt-40 {
    margin-top: 40px;
  }

  .form-control {

    color: #ffffff;
    background-color: #9191916b !important;
    background-clip: padding-box;
    border: 1px solid #ced4da75 !important;
  }

  .btn-outline-secondary {
    color: #ffffff;
    border-color: #ffffff;
  }

  .divider {
    font-size: 20px;
    margin: -0.65em auto -0.45em;
    overflow: hidden;
    text-align: center;
    line-height: 1.2em;
  }

  .divider:before,
  .divider:after {
    content: "";
    vertical-align: top;
    display: inline-block;
    width: 50%;
    height: 0.65em;
    border-bottom: 1px solid #fff;
    margin: 0 2% 0 -55%;
  }

  .divider:after {
    margin: 0 -55% 0 2%;
  }


  ::placeholder {
    color: #fff !important;
    opacity: 1;
    /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #fff !important;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #fff !important;
  }

  .form-control:focus {
    color: #ffffff !important;
  }

  @import url('../assets/style.css');
</style>